import { takeEvery, call, put, putResolve } from 'redux-saga/effects'
import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from './constants'
import { loanView } from 'src/store/loan'

function* fetch({ payload: { hash, nominalFlag, activeOperationsFlag, page }, meta: { ID } }) {
  try {
    // const { Data } = yield call(Loan.details, {
    //   ID,
    //   hash,
    //   page,
    //   additionalParams: {
    //     NominalFlag: nominalFlag,
    //     ActiveOperFlag: activeOperationsFlag,
    //   },
    // })

    // yield put(createAction(actions.FETCH_SUCCESS, { data: Data }, { ID }))

    //UPDATED API REQUEST loan_view_api page: operations
    const result = yield putResolve<any>(
      loanView({
        LoanID: ID,
        HashSum_LoanID_: hash,
        page,
        NominalFlag: nominalFlag,
        ActiveOperFlag: activeOperationsFlag,
      }),
    )

    if (!loanView.fulfilled.match(result)) {
      throw { Error: { Message: result.payload } }
    }

    yield put(createAction(actions.FETCH_SUCCESS, { data: result.payload }, { ID }))
  } catch (error) {
    console.error(error)

    yield put(createAction(actions.FETCH_FAILURE, error, { ID }))
  }
}

export default function* () {
  //@ts-ignore
  yield takeEvery(actions.FETCH, fetch)
}
